import PropTypes from "prop-types";
import SavedItemsProductTileList from "../../../../../../containers/common/SavedItemsProductTileList";
import SavedTilesCollection from "./SavedTilesCollection";
import isLastBestPriceEnabled from "../../../../../common/SavedItemsProductTiles/isLastBestPriceEnabled";
import { isFullyLoaded } from "../../../../../../../state/modules/savedItems/selectors/itemStateSelectors";
import useHandleResize from "./useHandleResize";

const SavedItemsProductTiles = ({
  savedItems,
  ProductTile,
  showDiscountLabel,
  isAuthenticated
}) => {
  const showExtendedPricing = isLastBestPriceEnabled();
  const { adPosition } = useHandleResize();

  return (
    <>
      <SavedItemsProductTileList>
        <SavedTilesCollection
          ProductTile={ProductTile}
          savedItems={savedItems}
          showDiscountLabel={showDiscountLabel}
          showExtendedPricing={showExtendedPricing}
          isAuthenticated={isAuthenticated}
          isFullyLoaded={isFullyLoaded}
          adPosition={adPosition}
        />
      </SavedItemsProductTileList>
    </>
  );
};

SavedItemsProductTiles.propTypes = {
  ProductTile: PropTypes.elementType.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  ),
  showDiscountLabel: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

export default SavedItemsProductTiles;
